import * as React from 'react';
import { Typography } from 'onboarding-components';
import { HeaderProps } from '../events/types';
import styles from './index.module.styl';
export const SectionHeader = (_ref: HeaderProps) => {
  let {
    title,
    subTitle
  }: HeaderProps = _ref;
  return <div data-sentry-component="SectionHeader" data-sentry-source-file="section-header.tsx">
      <Typography variant='headingXs' style={{
      marginTop: 0,
      marginBottom: 8
    }} data-sentry-element="Typography" data-sentry-source-file="section-header.tsx">
        {title}
      </Typography>
      <Typography className={styles.subtitle} variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="section-header.tsx">
        {subTitle}
      </Typography>
    </div>;
};